// semeia-disable-reexport
import dayjs from "dayjs";
import type { EmberChangeset } from "ember-changeset";
import Protocol from "parog-web/models/protocol";

export function updateFollowingCureDate({
  changeset,
  propertyName,
  timeValue,
  timeUnit,
  numberOfCures
}: {
  changeset: EmberChangeset;
  propertyName: string;
  timeValue: number;
  timeUnit: dayjs.ManipulateType;
  numberOfCures: number;
}): void {
  const match = propertyName?.match(/(\d+)Date/);
  if (!match || !match[1]) return;
  const cureIndex = parseInt(match[1]);
  let cureDay = changeset.get(propertyName);
  for (let i = cureIndex + 1; i <= numberOfCures; i++) {
    cureDay = dayjs(cureDay).add(timeValue, timeUnit).toDate();
    setCureDate(changeset, i, cureDay);
  }
}

export function setCureDate(
  changeset: EmberChangeset,
  index: number,
  date: Date | null
): void {
  changeset.set(Protocol.getCureDateId(index), date);
}
